import React, { useState, useEffect, useRef } from 'react';

import data from './Data';
import Property from './Property';
import SimpleTree from './SimpleTree';
import TableDesignView from './TableDesignView';
import { makeStyles } from '@material-ui/core/styles';
import './dnd.css'
import IconButton from "@material-ui/core/IconButton";
import DiagramIcon from '@material-ui/icons/DeviceHub';
// import ListIcon from '@material-ui/icons/Dehaze';
import AppsIcon from '@mui/icons-material/Apps';

// import TaskIcon from '@mui/icons-material/List';
import TaskIcon from '@mui/icons-material/PlaylistAdd';
import SubTaskIcon from '@mui/icons-material/PostAdd';
// import SubTaskIcon from '@mui/icons-material/ListAlt';
import TemplateIcon from '@mui/icons-material/DashboardCustomize';
// import recorder from '../img/recorder.png';
// import load from '../img/load.png';
// import playimg from '../img/play.png';
// import deploylocal from '../img/deploy-local.png';
// import deployimg from '../img/deploy.png';
// import clearimg from '../img/clear.png';
// import captureimg from '../img/capture.png';
// import extensionimg from '../img/extension.png';
import Dialog from './Dialog';
import FormDialog from './FormDialog';
import ConfigDialog from './ConfigDialog';
// import clouddownload from '../img/cloud-download.png';
// import cloudupload from '../img/cloud-upload.png';

import { LightTooltip } from './LightTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot, faList, faListAlt, faThLarge, faQuestionCircle, faSyncAlt, faTimesCircle, faWrench, faInfoCircle, faCog } from '@fortawesome/free-solid-svg-icons'
import Progress from './Progress';
import { DeployBot } from './botsdeployer/DeployBot';
// import {useStyles1} from './muistyles';


import BackIcon from '@material-ui/icons/ArrowBack';
import ForwardIcon from '@material-ui/icons/ArrowForward';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';

import DeleteIcon from '@mui/icons-material/DeleteOutline';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import PhotoCameraBackIcon from '@mui/icons-material/PhotoCameraBack';

import RecorderIcon from '@material-ui/icons/VideoCall';
import BotLoadIcon from '@material-ui/icons/FolderSpecial';
import TaskLoadIcon from '@material-ui/icons/Folder';
// import SubTasksLoadIcon from '@mui/icons-material/PostAdd';
import SubTasksLoadIcon from '@mui/icons-material/FolderOpen';

import TemplateLoadIcon from '@mui/icons-material/Source';

// import BotLoadIcon from '@mui/icons-material/Upload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import SaveLocalIcon from '@material-ui/icons/Save';
// import BotDeployRemoteIcon from '@material-ui/icons/ArrowForward';
import BotDeployRemoteIcon from '@material-ui/icons/ArrowForward';
import BotDeployLocallyIcon from '@material-ui/icons/ArrowDownward';

import CameraIcon from '@material-ui/icons/Camera';
// import ClearIcon from '@material-ui/icons/HighlightOff';
import ClearIcon from '@material-ui/icons/Backspace';
import PlayIcon from '@material-ui/icons/PlayCircleFilled';
import RobotIcon from '@mui/icons-material/SmartToy';
import ExtensionIcon from '@material-ui/icons/Extension';
import CredentialStoreIcon from '@material-ui/icons/Lock';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import {saveBotToLibrary,getBotListFromLibrary} from '../apis/bots'

import ReactFlow, {
    ReactFlowProvider,
    addEdge,
    isNode,
    isEdge,
    removeElements,
    getOutgoers,
    getIncomers,
    
    Controls, MiniMap, Background
  } from 'react-flow-renderer';  

  import BizNode from './BizNode';
  import IfNode from './IfNode';
  import LoopNode from './LoopNode';
  import MouseNode from './MouseNode';
  import EmailNode from './EmailNode';
  import FileNode from './FileNode';
  import WaitNode from './WaitNode';
  import BotNode from './BotNode';
  import CallNode from './CallNode';
  import RESTNode from './RESTNode';
  import KeyNode from './KeyNode';
  import RegularNode from './RegularNode';
  import SpeakerNode from './SpeakerNode';
  import SpeechToTextNode from './SpeechToTextNode';
  
  import BrowserNode from './BrowserNode';
  import nodeStyles from './nodeStyles';
  import message from './message';
  import customConnectionLine from './customConnectionLine';
  import getFields from './ActionFields';
  
  import ButtonEdge from './ButtonEdge';
  
  import { save } from 'save-file';
  // import ResizePanel from 'react-resize-panel';
import { render } from 'react-dom/cjs/react-dom.development';
import { isNonModelFieldType } from '@aws-amplify/datastore';
  
  const edgeStyle = {
    // stroke: '#9999ff',
    strokeWidth:1.7,
    // strokeOpactiy:0.1

  };


  

const initialElements = [
    {
      id: '1',
      type: 'input',
      data: { label: 'Start' },
      position: { x: 500, y: 10 },
      style: {
        // background: '#6789d7',
        // background: '#bfd6df',
        backgroundImage: 'linear-gradient(to bottom, #dccca9, lightgrey)',
        color: 'black',
        border: '2px solid white',
        borderRadius:'20px',
        boxShadow: '3px 5px 5px  #bababa',
        width: 150,
        fontSize: 16
      },
    }
    // {
    //     id: '2',
    //     type: 'output',
    //     data: { label: 'End' },
    //     position: { x: 250, y: 550 },
    //     style: {
    //       background: 'gray',
    //       color: 'white',
    //       border: '1px solid #222138',
    //       width: 180,
    //     },
    //   },
  
  ];

  const mysubtasks = ['one', 'two', 'three', 'four', 'five', 'six', 'seventysevennnn', 'eight', 'nine', 'ten'];

  const genericNodeStyleT = {
    borderRadius:'10px',
    background:' #d2daf2',
    background:'#bfd6df',
    background:'white',

    boxShadow: '5px 8px 8px  #bababa',

    color: '#ffe6ff',
    color: 'white',
    color: '#91a8ee',
    // border: '1px solid #222138',
    // width: 400,
    // height: 200,
    
  };

  const genericNodeStyleG = {
    // background:'#58bb99',
    background:'#bfd6df',
    background: 'white',
    borderRadius:'10px',
    boxShadow: '5px 8px 8px  #bababa',

    color: 'white',
    color: '#91a8ee',
    // border: '1px solid #222138',
    // width: 400,
    // height: 200,
    
  };


  // let nodeStyle = genericNodeStyle;
  let id = 3;
  const getId = () => `dnd_${id++}`;

  

export default function DesignerFlow(props)
{


  
  const [lastPosition, setLastPosition] = useState({ x:400, y:50})
    const [entityName, setEntityName] = useState('New')
    const [parentEntityName, setParentEntityName] = useState(null)
    const [parentObjectType, setParentObjectType] = useState(null)

    const [selectedElement, setSelectedElement] = useState(null)

    const [cutElement, setCutElement] = useState(undefined)

    const [map, setMap]=useState(new Map())
    const [show, setShow] = useState(false)
    const [showNameDialog, setShowNameDialog] = useState(false)
    const [showBotNameDialog, setShowBotNameDialog] = useState(false)
    const [showTaskNameDialog, setShowTaskNameDialog] = useState(false)
    const [showSubTaskNameDialog, setShowSubTaskNameDialog] = useState(false)
    const [showTemplateNameDialog, setShowTemplateNameDialog] = useState(false)

    const [showTask, setShowTask] = useState(false)
    const [showTemplate, setShowTemplate] = useState(false)
    const [showBotTemplate, setShowBotTemplate] = useState(false)
    const [showSubTask, setShowSubTask] = useState(false)


    const [showTaskLink, setShowTaskLink] = useState(false)
    const [showConfig, setShowConfig] = useState(false)
    const [showBotConfig, setShowBotConfig] = useState(false)
    const [botConfig, setBotConfig] = useState(null)
    const [showInfo, setShowInfo] = useState(false)
    const [botMapping, setBotMapping] = useState(null)
    const [transform, setTransform] = useState(null)
    const [botInfo, setBotInfo] = useState(null)
    const [template, setTemplate] = useState(null)

    const [bots, setBots] = useState([])
    const [botDetails, setBotDetails] = useState([])

    const [tasks, setTasks] = useState([])
    const [templates, setTemplates] = useState([])

    const [subtasks, setSubTasks] = useState([])


    const [selectedTab, setSelectedTab]= useState('Bot')
   // dummy variable to force render 
    const [counter, setCounter]=useState(0)

    const [fromElement, setFromElement] = useState('1')
    const [toElement, setToElement] = useState(undefined)

    const [viewType, setViewType] = useState("GRAPHICAL");

    const [objectType, setObjectType] = useState('BOT')
    const [progress, setProgress] = useState(1)
    const [loadBotFromLibrary,setLoadBotFromLibrary] = useState(false);
    const [showProgress, setShowProgress] = useState(false)
    const [showDeployBot, setShowDeployBot] = useState(false)

    const [history, setHistory] = useState([{name:'New', type:'BOT'}])  
    const[historyIndex, setHistoryIndex] = useState(0)

    const[uploadStatus, setUploadStatus] = useState("") 
    const [selectedNodes, setSelectedNodes] = React.useState(new Set());

    const getEntityName = () =>{
      return entityName
    }

    const getParentEntityName = () =>{
      return parentEntityName
    }

    const getParentObjectType = () =>{
      return parentObjectType
    }

    const getObjectType = () =>{
      return objectType
    }


    const deleteSelection = (selectedElement, detach=false) =>{
        
        if (selectedElement == undefined || selectedElement == null) {alert ("Please make a selection first"); return}

        // const nodeLabel = selectedElement.data.label
        // if (selectedElement.data.label == 'Start'){alert ("Can't Delete Start Node"); return} 

        removeElement(selectedElement.id);
        setSelectedElement(undefined);
        if (isEdge(selectedElement))
        {
          setFromElement(selectedElement.source);
          setToElement(selectedElement.target);
          return
        }

        if (!detach){
          // remember the from element 
          var nodes = getIncomers(selectedElement, elements);
          if (nodes[0] != undefined) setFromElement(nodes[0].id);
          else setFromElement(undefined);
        

        // get the next element
        var nodes = getOutgoers(selectedElement, elements);
        if (nodes[0] != undefined) 
          setToElement(nodes[0].id);
        else setToElement(undefined);
        }
        else{
          setFromElement(undefined)
          setToElement(undefined)
        }
      
        // saveCurrentEntity()
    }

    const deleteMultiSelection = () =>{
      selectedNodes.forEach(item => {
        removeElement(item)
      });
      setSelectedNodes(new Set())
      // saveCurrentEntity()
    }

    const clearSelection = (selectedElement) =>{
      if (selectedElement == undefined || selectedElement == null) {alert ("Please make a selection first"); return}

      var attributes = selectedElement.data.attributes
      for (let i = 0; i < attributes.length; i++) {
        attributes[i] = ""
        setSelectedElement(selectedElement)
      }
  }


  const onMappingChange = (evt) =>{
    setBotMapping(evt.target.value)
  }

  const onBotConfigChange = (evt) =>{
    setBotConfig(evt.target.value)
  }


  const onInfoChange = (evt) =>{
    setBotInfo(evt.target.value)
  }


  const onTransformChange = (evt) =>{
    setTransform(evt.target.value)
  }



  const onInfoSave = () =>{
    setShowInfo(false)
    console.log(botInfo)
    var info = botInfo.trim()

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body:info
    }
    console.log("Saving Info for : " + entityName)
    var endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "bot" + '/info/' + entityName 
    if (objectType == "SUBTASK")
      endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "subtask" + '/info/' + parentObjectType + "/" +  parentEntityName +  '/' + entityName

    else if (objectType == "TASK")
      endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "task" + '/info/'  + entityName

    else if (objectType == "TEMPLATE")
      endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "template" + '/info/'  + entityName



    fetch(endpoint, requestOptions)
    .catch(error => {        alert("Please ensure that your local agent is running")
  });

  }


  const onMapSave = () =>{
    setShowConfig(false)
    console.log(botMapping)
    var mapping = botMapping.trim()
    var array = []
    if (mapping != ""){
      array = mapping.split(',')
      for (var i = 0; i < array.length; i++)
      {
        array[i] = array[i].trim()
      }
    }
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body:JSON.stringify(array)
    }
    console.log("Saving mapping for : " + entityName)
    fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bot/config/' + entityName , requestOptions)
    .catch(error => {        alert("Please ensure that your local agent is running")
  });

  }


  const onBotConfigSave = () =>{
    setShowBotConfig(false)
    console.log(botConfig)
    var botconfig = botConfig.trim()
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body:botConfig
    }
    console.log("Saving bot config for : " + entityName)
    fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bot/botconfig/' + entityName , requestOptions)
    .catch(error => {        alert("Please ensure that your local agent is running")
  });

  }


    var ctrlDown = false,
    ctrlKey = 'Control',
    cmdKey = 'Cmd',
    vKey = 'KeyV',
    cKey = 'KeyC';

    var totalChildren = 0
    data.forEach(item => {
      totalChildren += item.children.length;
    });
    console.log("Actions Count: " +  totalChildren)

    if (localStorage.getItem('agentPort') == undefined ){
      localStorage.setItem('agentPort', 10001)
    }

    document.onkeydown = function(evt) {
        evt = evt || window.event;
        
        // if (evt.code == vKey) {
        //   if (ctrlDown) pasteNode()
        // }

        if (selectedElement == undefined) {return}
        
        // if (evt.code == cKey) {
        //   if (ctrlDown) copyNode(selectedElement)
        // }
        else
        // if (evt.code == 'Delete') deleteSelection(selectedElement)
        //   else
          if (evt.code == 'ArrowUp' && ctrlDown) {
            var nodes = getIncomers(selectedElement, elements)
            if (nodes[0] != undefined) setSelectedElement(nodes[0]);
          }
          else
          if (evt.code == 'ArrowDown' && ctrlDown) {
            var nodes = getOutgoers(selectedElement, elements)
            if (nodes[0] != undefined) setSelectedElement(nodes[0]);
          }

          console.log(evt.code)
          // detect copy paste
        if (evt.code != undefined && (evt.code.startsWith(ctrlKey) || evt.code.startsWith(cmdKey)) ) ctrlDown = true;
        

        }
        document.onkeyup = function (evt){
      
        if (evt.code != undefined && (evt.code.startsWith(ctrlKey) || evt.key.startsWith(cmdKey)) ) ctrlDown = false;
        }

    

    
    
    // useEffect(() => { 
    //   if (loading) return
    //   renderModel()
    // })

    const IFNodeStyle = {
      background: 'gray',
      color: 'purple',
      border: '1px solid #222138',
      textAlign: 'center',
      width: 600,
    };
  
    const reactFlowWrapper = useRef(null);
    const [reactFlowInstance, setReactFlowInstance] = useState(null);
    const [elements, setElements] = useState(initialElements);
    const onConnect = (params) => setElements((els) => addEdge({...params, type: 'buttonedge'}, els));
    const onElementsRemove = (elementsToRemove) =>
      setElements((els) => removeElements(elementsToRemove, els));
  
      const copyNodes=() =>{
        var list = []
        elements.map(item =>{
          selectedNodes.forEach(id => {
            if (item.id == id) {
              list.push(item);
            }
          });
        });
       
        localStorage.setItem('copiedNodes', JSON.stringify(list))
          
      }

      const copyNode  = (element) =>{
          if (element == undefined || element == null || isEdge(element)) { console.log("Nothing selected"); alert ("Please make a selection first"); return}
          var node = {
           data:element.data,
           type:element.type
         }
         var nodes = [node] 
         localStorage.setItem('copiedNodes', JSON.stringify(nodes))
        //  navigator.clipboard.writeText(JSON.stringify(node))
      } 

      const pasteNode  = () =>{
        var text = localStorage.getItem('copiedNodes')
        if (text == "" || text == undefined) return
        console.log('Pasted content: ', text);
        var nodes = JSON.parse(text)
        var startPositionX = 100
        var startPositionY = 200
         
        for (var i=0; i< nodes.length; i++){
          var position = reactFlowInstance.project({
            x: startPositionX,
            y: startPositionY + (100 * i)
          });
  
          const id = getId() 
          var node = nodes[i]
          const newNode = {
            id: id,
            type:node.type,
            position,
            style:getNodeStyle(), 
            data: node.data,
          };
          map.set(id, newNode)

          setSelectedElement(newNode)
    
          setElements((es) => es.concat(newNode));

          setFromElement(undefined)
          setToElement(undefined)
  
        }
        // saveCurrentEntity()
    
      } 

      const clearElements = (elementsToRemove)=>
      {
        if (elementsToRemove == null) return
        if (elementsToRemove.length == 0){return}
        
        onElementsRemove(elementsToRemove)

        // saveCurrentEntity()

      }
      const getNodeType = (name) => {

        if (name == "Task") {return "BizNode"}
        if (name == "Call") {return "CallNode"}
        if (name == "Bot") {return "BotNode"}
        if (name == "REST") {return "RESTNode"}
        if (name.startsWith("Mouse") || name.indexOf("Click") != -1 || name.indexOf("Move") != -1 ) {return "MouseNode"}
        if (name.indexOf("Email") == 0) {return "EmailNode"}
        if (name.indexOf ("File") != -1) {return "FileNode"}
        if (name.indexOf( "If" ) != -1) {return "IfNode"}
        if (name == "Key") {return "KeyNode"}
        if (name == "KeyInsert") {return "KeyNode"}
        if (name.startsWith("Loop")) {return "LoopNode"}
        if (name == "Wait") {return "WaitNode"}
        if (name == "Speaker") {return "SpeakerNode"}
        if (name == "SpeechToText") {return "SpeechToTextNode"}

        if (
          name.indexOf("Browser") != -1
          ||
            name.indexOf("Tab") != -1 
          || 
            name.indexOf("Window") != -1 
          || name.indexOf("Bar") != -1 
          )
          {return "BrowserNode"}
        
        return 'RegularNode'

    } 

    const renderBots = ()=>{
      
      return bots.map(bot => {
          return (
          <option value={bot}>{bot}</option>
          )
  
      });
      
  }

  const renderTasks = ()=>{
      
    return tasks.map(task => {
        return (
        <option value={task}>{task}</option>
        )

    });
    
  }

  const renderTemplates = ()=>{
      
    return templates.map(template => {
        return (
        <option value={template}>{template}</option>
        )

    });
    
  }


  const renderSubTasks = ()=>{
        
    return subtasks.map(subtask => {
        return (
        <option value={subtask}>{subtask}</option>
        )

    });
    
  }


  const showTemplateModal = ()=> {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'}
    }

    fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/templates/list/'  , requestOptions)
    .then (async response => {
      const data = await response.json();
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)  
      setTemplates(data)
      setShowTemplate(true)
    })

    .catch(error => {alert(        alert("Please ensure that your local agent is running")
    )});
}

  const showSubTasksModal = ()=> {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json'}
      }

      var endPoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/subtasks/list/' + objectType.toLowerCase() + '/' + entityName + '/' 
      if (objectType == "SUBTASK")
        endPoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/subtasks/list/' + parentObjectType.toLowerCase() + '/' + parentEntityName + '/'

      fetch(endPoint, requestOptions)
      .then (async response => {
        const data = await response.json();
        if (!response.ok) 
        {
          const error = (data && data.message) || response.status;
          console.log(error)
          return Promise.reject(error);
  
        }
        console.log(data)  
        setSubTasks(data)
        setShowSubTask(true)
      })

      .catch(error => {alert(        alert("Please ensure that your local agent is running")
      )});
  }


  const showTasksModal = ()=> {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json'}
      }
  
      fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/tasks/list/'  , requestOptions)
      .then (async response => {
        const data = await response.json();
        if (!response.ok) 
        {
          const error = (data && data.message) || response.status;
          console.log(error)
          return Promise.reject(error);
  
        }
        console.log(data)  
        setTasks(data)
        setShowTask(true)
      })

      .catch(error => {alert(        alert("Please ensure that your local agent is running")
      )});
  }



  const showModal = ()=> {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json'}
      }
  
      fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/list/'  , requestOptions)
      .then (async response => {
        const data = await response.json();
        if (!response.ok) 
        {
          const error = (data && data.message) || response.status;
          console.log(error)
          return Promise.reject(error);
  
        }
        console.log(data)  
        setBots(data)
        setShow(true)
      })

      .catch(error => {
        // alert(error)
        alert("Please ensure that your local agent is running")
      });
  }


  




    const removeElement = (id) =>{
      var list = []
      elements.map(item =>{

        if (item.id == id) {
          list.push(item);
        }

      });      
      clearElements(list)
    }


    const getNearestSourceElement = (y)=>{

      var Y = 0
      var sourceElement = undefined
      elements.map(item =>{ 
        console.log(item)
        var pos = item['position']
        if (pos == undefined) return undefined
        pos = pos['y']
        if (pos  < y && pos > Y)
        {
          Y = pos
          sourceElement = item
          console.log(sourceElement)
        }
        
      });
      return sourceElement
    }

    const getNodeStyle = () =>{
      var nodeStyle = genericNodeStyleT

      return nodeStyle

    }
    const onLoad = (_reactFlowInstance) =>
      setReactFlowInstance(_reactFlowInstance);
  
    const onDragOver = (event) => {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';


      // const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      // var y =  event.clientY - reactFlowBounds.top
      // var element = getNearestSourceElement(y)

    };

    const onDrop = (event) => {
      event.preventDefault();

      const reactFlowBounds = reactFlowWrapper.current.getBoundingClientRect();
      const type = event.dataTransfer.getData('application/reactflow');
      if (type == undefined || type == '') return
      // var attributes = event.dataTransfer.getData('attributes');

      var name = event.dataTransfer.getData('name');
      var attributes = getFields(name)
      // attributes.push('checkDisabled')
      var classType = event.dataTransfer.getData('classType')
      if (classType == "undefined" || classType == null || classType == '') 
      { classType = "events."  + name + "Event";}
      console.log ("classType:" + classType)
      console.log(name)
      console.log(attributes)

      // commenting the popup for name
      // var instanceName = ''
      // if (name == "Task" || name=="If" || name== "LoopImageMatch")
      // {
      //   instanceName = prompt("Enter Name", "Name")
      //   //nodeStyle = getNodeStyle(name)
      //   name=name + ":" + instanceName 
      // }

      const position = reactFlowInstance.project({
        x: event.clientX - reactFlowBounds.left,
        y: event.clientY - reactFlowBounds.top,
      });
      const id = getId() 

      const newNode = {
        id: id,
        type,
        position,
        style:getNodeStyle(), 
        data: { label: name, objectType:objectType, parentObjectType:parentObjectType, parentEntityName: parentEntityName, attributes:attributes, classType: classType, entity:entityName, selected:true },
      };
      map.set(id, newNode)
      // if (selectedElement != undefined && selectedElement != null)
      // {
      //   selectedElement.data.isSelected=false
      //   setSelectedElement(newNode)
      //   newNode.data.isSelected=true
      // }
        setSelectedElement(newNode)

      setElements((es) => es.concat(newNode));

    //   var y =  event.clientY - reactFlowBounds.top
    //   var sourceElement = getNearestSourceElement(y)
    //   var destinationElement = undefined
    //   if (sourceElement != undefined) 
    //     destinationElement = getOutgoers(sourceElement)[0]

    //   if ( sourceElement != undefined)
    //   {
    //     const edgeId1 = sourceElement + '-' + id

    //     const newEdge1 = 
    //     {
    //       id: edgeId1,
    //       source: sourceElement,
    //       target: id,
    //       style:edgeStyle,
    //       type:'step',
    //       // animated: true,
    //       arrowHeadType: 'arrow',
    //     }
    //     setElements((es) => es.concat(newEdge1));
    //     map.set(edgeId1, newEdge1)

    //   }
    //   if (destinationElement != undefined)
    //   {
    //     const edgeId2 = id + '-' + toElement

    //     const newEdge2 = 
    //     {
    //       id: edgeId2,
    //       source: id,
    //       target: destinationElement,
    //       style:edgeStyle,
    //       type:'step',
    //       // animated: true,
    //       arrowHeadType: 'arrow',
    //     }
    //     setElements((es) => es.concat(newEdge2));
    //     map.set(edgeId2, newEdge2)
    //     setFromElement(undefined)
    //     setToElement(undefined)
    //   }
    //   else
    //   setFromElement(newNode.id)
      

    //   // setElements((es) => es.concat(newEdge2));
       
    // };



      if ( fromElement != undefined)
      {
        const edgeId1 = fromElement + '-' + id

        const newEdge1 = 
        {
          id: edgeId1,
          source: fromElement,
          target: id,
          style:edgeStyle,
          type:'step',
          // animated: true,
          arrowHeadType: 'arrow',
        }
        setElements((es) => es.concat(newEdge1));
        map.set(edgeId1, newEdge1)

      }
      if (toElement != undefined)
      {
        const edgeId2 = id + '-' + toElement

        const newEdge2 = 
        {
          id: edgeId2,
          source: id,
          target: toElement,
          style:edgeStyle,
          type:'step',
          // animated: true,
          arrowHeadType: 'arrow',
        }
        setElements((es) => es.concat(newEdge2));
        map.set(edgeId2, newEdge2)
        setFromElement(undefined)
        setToElement(undefined)
      }
      else
      setFromElement(newNode.id)
      

      // setElements((es) => es.concat(newEdge2));
      // saveCurrentEntity() 
    };
  
    const onElementClick = (event, element) => {
        // event.preventDefault();
        // if (selectedElement != undefined && selectedElement != null)
        // {

        //   selectedElement.data.isSelected=false
        //   setSelectedElement(element)
        //   element.data.isSelected=true
        // }
          setSelectedElement(element)
  

    }

    const onElementDoubleClick = (event, element) => {
      event.preventDefault();
      console.log("DoubleClick")
  }




  

    const updateProperties = (properties) => {
        selectedElement.data.attributes = properties

    }

    // used to load  subtask, task and bot 
    const loadModel = (botname, content, thisObjectType="BOT", parentObjectType="", parentEntityName="") => {
        
          clearElements(elements.slice(1))
          setSelectedElement(elements[0])
          setFromElement('1')
          elements[0].data.label= "Start"
          var lastPosition = { x:400, y:50}
          const events = JSON.parse(content)
 
          var sourceElement = '1'
          // vertical distance between nodes
          var increment = 300
          events.map(item => {
          var id = getId()
          var position = {x:lastPosition.x , y: lastPosition.y + increment}
          var name = item["py/object"]
          var ind1 = name.indexOf('.')
          var ind = name.lastIndexOf('Event')
          name = name.substring(ind1+1, ind)
          const type = getNodeType(name)
          
          const newNode = {
            id: id,
            type,
            position,
            style:getNodeStyle(), 
            data: { type:type, label: name, objectType: thisObjectType, parentObjectType:parentObjectType, parentEntityName: parentEntityName, attributes:item, entity:botname }
          };
    
          setElements((es) => es.concat(newNode));
          map.set(id, newNode)

          if ( sourceElement != null)
          {
            const edgeId = fromElement + '-' + id
    
            const newEdge = 
            {
              id: edgeId,
              source: sourceElement,
              style:{strokeWidth:1.7},
              target: id,
              type:'step',
              arrowHeadType: 'arrow',
            }
             
            setElements((es) => es.concat(newEdge));
            map.set(edgeId, newEdge)
          }
    
          sourceElement = newNode.id          
          lastPosition = position
    

        });
        setFromElement(sourceElement)
  
        setLastPosition(lastPosition);
  
        return true;
  
      }

      const getModelJSON = ()=>{
        var events=[];
        if (elements.length == 0) return "[]";

        // skip this element as it is Begin
        var element = elements[0];
        var action = ''
        // var action = { "py/object":"events." + element.data.label + "Event"}
        // Object.assign(action, element.data.attributes)
        // events.push(action)

        var nodes = getOutgoers(element, elements);
        if (nodes == null) return "[]";
        var node = nodes[0];

        while (node != null ){
        if (node.data != undefined &&  node.data != null)
        {
            var classType = node.data.classType
            if (classType == undefined || classType == null || classType == '') 
            {classType = 'events.' +  node.data.label + "Event"}
            action = { "py/object":classType}
            Object.assign(action, node.data.attributes)
            console.log(action)
            events.push(action)

        }
        element = node;
        nodes = getOutgoers(element, elements);
        node = nodes[0]; 

      }
        return JSON.stringify(events) 
      }

      const addHistory = (item) =>{
          // Remove items after the current history index.
          if (historyIndex != 0 )
          {
              history.splice(historyIndex + 1);
          }
          history.push(item);
          setHistoryIndex(historyIndex + 1);

      }

      const loadBot =(botname, pushHistory = true, index = 0) =>
      {
        open(botname)
        setShow(false)
        setEntityName(botname)
        setObjectType("BOT")
        if ( pushHistory )
        {
          addHistory({ name: botname, type: "BOT" });
        }
        else
          setHistoryIndex(index)

      }

      const onBotLoad = ()=>{
        const botname = document.getElementById('botinp').value
        loadBot(botname)
      }

      const loadTask = (taskname, pushHistory = true, index=0) =>{
        openTask(taskname)
        setShowTask(false)
        setEntityName(taskname)
        setObjectType("TASK")
        if ( pushHistory )
        {
          addHistory({name:taskname, type:"TASK"})
        }
        else
          setHistoryIndex(index)


      }

      const loadTemplate = (templatename, pushHistory = true, index=0) =>{
        openTemplate(templatename)
        setShowTemplate(false)
        setEntityName(templatename)
        setObjectType("TEMPLATE")
        if ( pushHistory )
        {
          addHistory({name:templatename, type:"TEMPLATE"})
        }
        else
          setHistoryIndex(index)


      }

      const importSubTasksFromTemplate = (templatename,botName)=>{
        var json = getModelJSON(); 
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json'},
          body:json
        }
        console.log("Importing template : " + templatename)
        var endPoint = "http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/template/copy/" + templatename + "/" + botName 

        fetch(endPoint, requestOptions)
        .catch(error => {
          alert("Please ensure that your local agent is running")
        });

      }

      const loadBotFromTemplate = (botName, pushHistory = true, index=0) =>{
        openTemplate(template)
        setShowBotTemplate(false)
        setEntityName(botName)
        setObjectType("BOT")
        if ( pushHistory )
        {
          addHistory({name:botName, type:"BOT"})
        }
        else
          setHistoryIndex(index)

        importSubTasksFromTemplate(template, botName)
        // saveCurrentEntity()


      }


      const loadSubTask = (subtaskname, parentObjectType, parentEntityName, pushHistory = true, index=0) =>{
        openSubTask(subtaskname, parentObjectType, parentEntityName)
        setShowSubTask(false)
        setEntityName(subtaskname)
        setObjectType("SUBTASK")
        if ( pushHistory )
        {
          addHistory({name:subtaskname, type:"SUBTASK", parentObjectType:parentObjectType, parentEntityName:parentEntityName})
        }
        else
          setHistoryIndex(index)


      }



      const onTaskLoad = ()=>{
        const taskname = document.getElementById('taskinp').value
        loadTask(taskname)
        // openTask(taskname)
        // setShowTask(false)
        // setEntityName(taskname)
        // setObjectType("TASK")
      }
      const onTaskLink = ()=>{
        const taskname = document.getElementById('tasklinkinp').value

        setShowTaskLink(false)
      }

      // for loading bot from new template  
      const handleOK = ()=>{
        setShowNameDialog(false)
        const name = document.getElementById('newEntityName').value
        setEntityName(name)
        loadBotFromTemplate(name)
        addHistory({name:name, type:"BOT"})

      }
      const handleBotOK = ()=>{
        setShowBotNameDialog(false)
        const name = document.getElementById('newEntityName').value
        setEntityName(name)
        addHistory.push({name:name, type:"BOT"})

      }

      const handleTaskOK = ()=>{
        setShowTaskNameDialog(false)
        const name = document.getElementById('newEntityName').value
        setEntityName(name)
        addHistory({name:name, type:"TASK"})

      }

      const handleSubTaskOK = ()=>{
        setShowSubTaskNameDialog(false)
        const name = document.getElementById('newEntityName').value
        addHistory({name:name, type:"SUBTASK", parentObjectType:parentObjectType, parentEntityName:parentEntityName})
        setEntityName(name)

      }

      const handleTemplateOK = ()=>{
        setShowTemplateNameDialog(false)
        const name = document.getElementById('newEntityName').value
        setEntityName(name)
        addHistory({name:name, type:"TEMPLATE"})

      }



      const onTemplateLoad = ()=>{
        const templatename = document.getElementById('templateinp').value
        loadTemplate(templatename)
      }


      const onTemplateLoadBot = ()=>{
        const templatename = document.getElementById('templateinp').value
        setTemplate(templatename)
        setShowNameDialog(true)
        // loadBotFromTemplate(templatename)
      }


      const onSubTaskLoad = ()=>{
        const subtaskname = document.getElementById('subtaskinp').value
        if (objectType == "SUBTASK")
          loadSubTask(subtaskname, parentObjectType, parentEntityName)
        else
        {
          loadSubTask(subtaskname, objectType, entityName)

          setParentObjectType(objectType)
          setParentEntityName(entityName)
        }
      }


      const saveModel = (event) =>
      {
        event.preventDefault();
        save(getModelJSON(), entityName + ".rec")

     
      }

      const deployRemote = (event) =>
      {
        setShowDeployBot(true);
      }

      const deployLocally = (event) =>
      {
        event.preventDefault();
        var json = getModelJSON(); 
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json'},
          body:json
        }
        console.log("deploying local: " + entityName)
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/bots/register/' + entityName , requestOptions)
        .catch(error => {        alert("Please ensure that your local agent is running")
      });

      }


      const saveObject = (event) =>{
        event.preventDefault();

        saveCurrentEntity()        

      }

      function saveCurrentEntity () {
        if (objectType == "BOT")
        {
          deployModel()
          return
        }

        var json = getModelJSON(); 
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json'},
          body:json
        }
        console.log("saving local: " + entityName)
        var endPoint  = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/task/'
        if (objectType == "SUBTASK") 
        { endPoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/subtask/' + parentObjectType + "/" +  parentEntityName + '/'}
        if (objectType == "TEMPLATE") 
        { endPoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/template/' }

        fetch(endPoint + entityName , requestOptions)
        .catch(error => {
          console.log(error)
          alert("Please ensure that your local agent is running")
        });

      }

      const deployModel = () =>
      {
        var json = getModelJSON(); 
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json'},
          body:json
        }
        console.log("deploying local: " + entityName)
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/deploy/' + entityName , requestOptions)
        .catch(error => {           
          console.log(error)
          alert("Please ensure that your local agent is running")
      });
        
      }
      const clearModel = (event) =>
      {
        event.preventDefault();
        // clear();

        clearElements(elements.slice(1))
        setSelectedElement(elements[0])
        setFromElement('1')
        setLastPosition({ x:400, y:50})
        map.clear()
        // setEntityName ( "New")
      }

      const extend = () => {

        // updateModel(JSON.stringify(filesContent))
        setSelectedElement(null)  

      }

      
      const cStore = () => {


      }
      const cStoreCloud = () => {


      }

      const screenClip = (name) =>
      {
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json'},
          body:JSON.stringify({"name": name, "folder":objectType == 'BOT'? 'bots':'tasks'})
        }
    
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/bots/execute/screenClip' , requestOptions)
        .catch(error => {alert(        alert("Please ensure that your local agent is running")
        )});
    
      }

      const record = () =>
      {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
        }
    
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/bots/execute/recorder' , requestOptions)
        .catch(error => {alert(        alert("Please ensure that your local agent is running")
        )});
    
      }

      const capture = () =>
      {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
        }
    
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/bots/execute/capture' , requestOptions)
        .catch(error => {alert(        alert("Please ensure that your local agent is running")
        )});
    
      }


      const play = () =>
      {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
        }
    
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/bots/execute/'+ entityName , requestOptions)
        .catch(error => {alert(        alert("Please ensure that your local agent is running")
        )});
    
      }

      

      const open = (botname) =>
      {
        if(loadBotFromLibrary){


          setLoadBotFromLibrary(false)
        }else{

          const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json'}
          }
          
          fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/load/'+ botname , requestOptions)
          .then (async response => {
            const data = await response.text();
            if (!response.ok) 
            {
              const error = (data && data.message) || response.status;
              console.log(error)
              return Promise.reject(error);
      
            }
            loadModel(botname, data);
          })
    
          .catch(error => {
            // alert(error)
            alert ("Bot " + botname + " does not exist. You can continue to edit this freshly created Bot")
          });
        }


      }

      const openTask = (taskname) =>
      {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
        }
    
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/tasks/load/'+ taskname , requestOptions)
        .then (async response => {
          const data = await response.text();
          if (!response.ok) 
          {
            const error = (data && data.message) || response.status;
            console.log(error)
            return Promise.reject(error);
    
          }
          loadModel(taskname, data, "TASK");
        })
  
        .catch(error => {
          // alert(error)
          alert("Task " + taskname + " doesn't exist - you will now be editing it fresh")
        }
        );


      }


      const openTemplate = (templatename) =>
      {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
        }
    
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/templates/load/'+ templatename , requestOptions)
        .then (async response => {
          const data = await response.text();
          if (!response.ok) 
          {
            const error = (data && data.message) || response.status;
            console.log(error)
            return Promise.reject(error);
    
          }
          loadModel(templatename, data, "TEMPLATE");
        })
  
        .catch(error => {
          // alert(error)
          alert("Template " + templatename + " doesn't exist - you will now be editing it fresh")
        }
        );


      }
 

      const openSubTask = (subtaskname, parentObjectType, parentEntityName) =>
      {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
        }
    
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/subtasks/load/' + parentObjectType +  "/" + parentEntityName + "/" + subtaskname , requestOptions)
        .then (async response => {
          const data = await response.text();
          if (!response.ok) 
          {
            const error = (data && data.message) || response.status;
            console.log(error)
            return Promise.reject(error);
    
          }
          loadModel(subtaskname, data, "SUBTASK", parentObjectType, parentEntityName);
        })
  
        .catch(error => {
          // alert(error)
          alert("SubTask " + subtaskname + " doesn't exist - you will now be editing it fresh")
        }
        );


      }




      const renderBotMapping = () =>{
        return (
          <div>
            <h5 style={{color:'royalblue'}}>Comma Separated Input Params</h5>
            <textarea className ='areavalue' rows="10" cols="50" value={botMapping} onChange={onMappingChange}></textarea>
          </div>

        )
      }

      const renderBotConfig = () =>{
        return (
          <div>
            <h5 style={{color:'royalblue'}}>Bot Properties</h5>
            <textarea className ='areavalue' rows="10" cols="50" value={botConfig} onChange={onBotConfigChange}></textarea>
            
          </div>

        )
      }



      const renderBotInfo = () =>{
        return (
          <div>
            <h5 style={{color:'royalblue'}}>Documentation</h5>
            <textarea className ='areavalue' rows="10" cols="50" value={botInfo} onChange={onInfoChange}></textarea>
            
          </div>

        )
      }


      //save bot to library
      const uploadCloud = () =>{

        saveBotToLibrary(entityName,setShowProgress,setProgress,progress,setUploadStatus)
        
      }
      
      //Load from bot library
      const downloadCloud = () =>{

        // getBotListFromLibrary().then(bots =>{
        //   let botlist = bots.map(bot=> {
        //     return bot.botName
        //   })
        //   console.log(`Display botlist: ${botlist}`)
        //   setBots(botlist);
        //   setBotDetails
        //   setShow(true);
        //   setLoadBotFromLibrary(true);

        // });

      }

      function updateMode (isGraphicalMode){
          var newElements = elements
          for (var i = 1; i < elements.length; i++)
          if (isNode(newElements[i]))  
            newElements[i].data.isGraphicalMode = isGraphicalMode
          
          setElements(newElements)  
      }

      function renderModeIcon(){
        if(viewType == "TABULAR"){
          return(
          // <div className = 'mini-toolbar'>
          <LightTooltip title="Graphical View">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                  setViewType("GRAPHICAL");
                  updateMode(true)
                  }}>
                <DiagramIcon fontSize="small" style={iconStyle}/>

              </IconButton>
          </LightTooltip>


        //  </div>
          );
        }

        else if(viewType == 'GRAPHICAL'){
          return(
          // <div className = 'mini-toolbar'>

          <LightTooltip title="Tabular view">
              <IconButton className="toolbutton" variant="contained"
                color="primary" size="small" className={classes.designerIconButton} onClick={()=>{
                  setViewType("TABULAR");
                  updateMode(false)
                  }}>
                <AppsIcon fontSize="small" style={iconStyle}/>

              </IconButton>
          </LightTooltip>
          // </div>
          );

        }
      }

      function miniToolBar(){
          return (

          <div className="mini-toolbar">
            {renderModeIcon()}
          <br/>
          <LightTooltip title="Copy">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                  if (viewType == "GRAPHICAL")
                    copyNode(selectedElement)
                  else
                    copyNodes()

                  }}>
                <ContentCopyIcon fontSize="small" className='miniButton'/>

              </IconButton>
          </LightTooltip>

          <LightTooltip title="Delete">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                  if (viewType == "GRAPHICAL")
                  deleteSelection(selectedElement)
                  else
                  deleteMultiSelection()

                  }}>
                <DeleteIcon fontSize="small" className='miniButton'/>

              </IconButton>
          </LightTooltip>

          <LightTooltip title="Cut">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                    copyNode(selectedElement)
                    setCutElement(selectedElement)
                  }}>
                <ContentCutIcon fontSize="small" className='miniButton'/>

              </IconButton>
          </LightTooltip>


          <LightTooltip title="Paste">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                  pasteNode()
                  if (cutElement != undefined) { deleteSelection(cutElement); setCutElement(undefined)}
                }}>
                <ContentPasteIcon fontSize="small" className='miniButton'/>

              </IconButton>
          </LightTooltip>

          <LightTooltip title="Clip Image From Screen">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                  screenClip(entityName)
                }}>
                <PhotoCameraBackIcon fontSize="small" className='miniButton'/>

              </IconButton>
          </LightTooltip>

          <LightTooltip title="Capture Images">
            <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small" onClick={capture}>
                <CameraIcon fontSize="small" className='miniButton'/>
              </IconButton>
            </LightTooltip>


          {/* <LightTooltip title="Clear Values">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                  clearSelection(selectedElement)
                  }}>
                <CleaningServicesIcon fontSize="small" style={miniBarIconStyle}/>

              </IconButton>
          </LightTooltip> */}




          <LightTooltip title="Detach">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                  if ( selectedElement == undefined || selectedElement == null ) { alert ("Please make a selection first"); return}
                  
                  copyNode(selectedElement)

                  deleteSelection(selectedElement, true)
                  pasteNode()
                  }}>
                <LinkOffIcon fontSize="small" className='miniButton'/>

              </IconButton>
          </LightTooltip>


          {/* <LightTooltip title="Disable">
              <IconButton className="toolbutton" variant='contained' 
                color="primary" size="small"  onClick={()=>{
                  // disableSelection()
                  }}>
                <DoNotDisturbAltIcon fontSize="small" className='miniButton'/>

              </IconButton>
          </LightTooltip> */}

          </div>
          );

      }


      const createBot = (event) =>{
        clearModel(event)
        setObjectType("BOT")
        setShowBotNameDialog(true)

      }

      const createBotFromTemplate = (event) =>{
        clearModel(event)
        setObjectType("BOT")

        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json'}
        }
    
        fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/templates/list/'  , requestOptions)
        .then (async response => {
          const data = await response.json();
          if (!response.ok) 
          {
            const error = (data && data.message) || response.status;
            console.log(error)
            return Promise.reject(error);
    
          }
          console.log(data)  
          setTemplates(data)
          setShowBotTemplate(true)
        })
    
        .catch(error => {alert(        alert("Please ensure that your local agent is running")
        )});
    
      }


      const createTask = (event) =>{
        clearModel(event)
        setObjectType("TASK")
        setShowTaskNameDialog(true)

      }
      const createTemplate = (event) =>{
        clearModel(event)
        setObjectType("TEMPLATE")
        setShowTemplateNameDialog(true)

      }


      const createSubTask = (event) =>{
        if (objectType == "SUBTASK")
          alert("Editing subtask under " + parentObjectType +  " " + parentEntityName)
        else
        {
          setParentEntityName(entityName)
          setParentObjectType(objectType)
        }
        clearModel(event)
        setObjectType("SUBTASK")
        setShowSubTaskNameDialog(true)

      }


    
      const toolbar = () => {
        return (
          <div className="toolbar">
            <LightTooltip title="Launch Recorder">
              <IconButton className="toolbutton" onClick={record}>
                <RecorderIcon fontSize="medium" />
              </IconButton>
            </LightTooltip>


            <LightTooltip title="Create New Bot">
            <IconButton className="toolbutton" onClick={createBot}>
              <FontAwesomeIcon   onClick={onTabClick} name='Bot' icon={faRobot} size='xs'/>
              </IconButton>
            </LightTooltip>


            <LightTooltip title="Create New Task">
            <IconButton className="toolbutton" onClick={createTask}>
              {/* <FontAwesomeIcon   name='Task' icon={faList} size='small'/> */}
              <TaskIcon fontSize="medium" />
              </IconButton>
            </LightTooltip>

            <LightTooltip title="Create New Sub Task">
            <IconButton className="toolbutton" onClick={createSubTask}>
              {/* <FontAwesomeIcon   name='SubTask' icon={faList} size='small'/> */}
              <SubTaskIcon fontSize="medium" />
              </IconButton>
            </LightTooltip>

            <LightTooltip title="Create New Template">
            <IconButton className="toolbutton" onClick={createTemplate}>
              <TemplateIcon fontSize="medium" />
              </IconButton>
            </LightTooltip>

            <LightTooltip title="Create New Bot From Template">
            <IconButton className="toolbutton" onClick={createBotFromTemplate}>
            <RobotIcon fontSize="medium" />
              </IconButton>
            </LightTooltip>


            <LightTooltip title="Open Bot from local disk">
            <IconButton className="toolbutton" onClick={showModal}>
                <BotLoadIcon fontSize="small" />
              </IconButton>
            </LightTooltip>


            <LightTooltip title="Open Task from local disk">
            <IconButton className="toolbutton" onClick={showTasksModal}>
                <TaskLoadIcon fontSize="small" />
              </IconButton>
            </LightTooltip>

            <LightTooltip title="Open Sub Task from local disk">
            <IconButton className="toolbutton" onClick={showSubTasksModal}>
                <SubTasksLoadIcon fontSize="small" />
              </IconButton>
            </LightTooltip>

            <LightTooltip title="Open Template from local disk">
            <IconButton className="toolbutton" onClick={showTemplateModal}>
                <TemplateLoadIcon fontSize="small" />
              </IconButton>
            </LightTooltip>


            <LightTooltip title="Save Locally">
            <IconButton className="toolbutton" onClick={saveObject}>
                <SaveLocalIcon fontSize="small" />
              </IconButton>
            </LightTooltip>


            <LightTooltip title="Play Bot Recording">
            <IconButton className="toolbutton" onClick={play}>
                <PlayIcon fontSize="small" />
              </IconButton>
            </LightTooltip>


            <LightTooltip title="Clear Canvas">
            <IconButton className="toolbutton" onClick={clearModel}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </LightTooltip>


            <LightTooltip title="Load from Bot Library">
            <IconButton className="toolbutton" onClick={downloadCloud}>
                <CloudDownloadIcon fontSize="medium" />
              </IconButton>
            </LightTooltip>

            <LightTooltip title="Save to Bot Library">
            <IconButton className="toolbutton" onClick={uploadCloud}>
                <CloudUploadIcon fontSize="small" />
              </IconButton>
            </LightTooltip>


            {/* <LightTooltip title="Capture Images">
            <IconButton className="toolbutton" onClick={capture}>
                <CameraIcon fontSize="medium" />
              </IconButton>
            </LightTooltip> */}

            <LightTooltip title="Local Credential Store">
            <IconButton className="toolbutton" onClick={cStore}>
                <CredentialStoreIcon fontSize="small" />
              </IconButton>
            </LightTooltip>

            <LightTooltip title="Cloud Credential Store">
            <IconButton className="toolbutton" onClick={cStoreCloud}>
                <EnhancedEncryptionIcon fontSize="small" />
              </IconButton>
            </LightTooltip>


            {/* <LightTooltip title="Deploy Remote">
            <IconButton className="toolbutton" onClick={deployRemote}>
                <BotDeployRemoteIcon fontSize="medium" />
              </IconButton>
            </LightTooltip> */}

            {/* <LightTooltip title="Deploy Locally">
            <IconButton className="toolbutton" onClick={deployLocally}>
                <BotDeployLocallyIcon fontSize="medium" />
              </IconButton>
            </LightTooltip> */}


            {/* <LightTooltip title="Import Extensions">
            <IconButton className="toolbutton" onClick={extend}>
                <ExtensionIcon fontSize="medium" />
              </IconButton>
            </LightTooltip> */}

            <ConfigDialog
              title={"Bot Input"}
              // message={"Comma Separated Input Params"}
              handleSave={onMapSave}
              open={showConfig}
              setOpen={setShowConfig}
              render={renderBotMapping}
            ></ConfigDialog>

            <ConfigDialog
              title={"Documentation"}
              // message={"Comma Separated Input Params"}
              handleSave={onInfoSave}
              open={showInfo}
              setOpen={setShowInfo}
              render={renderBotInfo}
            ></ConfigDialog>

            <ConfigDialog
              title={"Bot Config"}
              handleSave={onBotConfigSave}
              open={showBotConfig}
              setOpen={setShowBotConfig}
              render={renderBotConfig}
            ></ConfigDialog>



            <Dialog
              title={"Open Bot"}
              message={"Pick your bot from the list below"}
              handleLoad={onBotLoad}
              open={show}
              setOpen={setShow}
              render={renderBots}
              inp='botinp'
            ></Dialog>


            <Dialog
              title={"Open Task"}
              message={"Pick your task from the list below"}
              handleLoad={onTaskLoad}
              open={showTask}
              setOpen={setShowTask}
              render={renderTasks}
              inp='taskinp'
            ></Dialog>

            <Dialog
              title={"Open Template"}
              message={"Pick your template from the list below"}
              handleLoad={onTemplateLoad}
              open={showTemplate}
              setOpen={setShowTemplate}
              render={renderTemplates}
              inp='templateinp'
            ></Dialog>

            <Dialog
              title={"New Bot From Template"}
              message={"Pick your template from the list below"}
              handleLoad={onTemplateLoadBot}
              open={showBotTemplate}
              setOpen={setShowBotTemplate}
              render={renderTemplates}
              inp='templateinp'
            ></Dialog>

            <FormDialog
              title={"Provide Name"}
              message={"Please provide a name for your new bot"}
              open={showNameDialog}
              setOpen={setShowNameDialog}
              handleOK={handleOK}
              inp='newEntityName'
            ></FormDialog>


            <FormDialog
              title={"Provide SubTask Name"}
              message={"Please provide a name for your new subtask"}
              open={showSubTaskNameDialog}
              setOpen={setShowSubTaskNameDialog}
              handleOK={handleSubTaskOK}
              inp='newEntityName'
            ></FormDialog>


            <FormDialog
              title={"Provide Template Name"}
              message={"Please provide a name for your new template"}
              open={showTemplateNameDialog}
              setOpen={setShowTemplateNameDialog}
              handleOK={handleTemplateOK}
              inp='newEntityName'
            ></FormDialog>


            <FormDialog
              title={"Provide Task Name"}
              message={"Please provide a name for your new task"}
              open={showTaskNameDialog}
              setOpen={setShowTaskNameDialog}
              handleOK={handleTaskOK}
              inp='newEntityName'
            ></FormDialog>

            <FormDialog
              title={"Provide Bot Name"}
              message={"Please provide a name for your new bot"}
              open={showBotNameDialog}
              setOpen={setShowBotNameDialog}
              handleOK={handleBotOK}
              inp='newEntityName'
            ></FormDialog>




            <Dialog
              title={"Open Sub Task"}
              message={"Pick your sub-task from the list below"}
              handleLoad={onSubTaskLoad}
              open={showSubTask}
              setOpen={setShowSubTask}
              render={renderSubTasks}
              inp='subtaskinp'
            ></Dialog>





            <Dialog
              title={"Link Task"}
              message={"Pick your task from the list below"}
              handleLoad={onTaskLink}
              open={showTaskLink}
              setOpen={setShowTaskLink}
              render={renderTasks}
              inp='tasklinkinp'
            ></Dialog>



          </div>
        );
      };




      // onSelectionContextMenu(event: MouseEvent, nodes: Node[]): called when user does a right-click on a selection
      // onPaneClick(event: MouseEvent): called when user clicks directly on the canvas
      // onPaneContextMenu(event: MouseEvent): called when user does a right-click on the canvas

    const onSelectionContextMenu=(event, nodes) => {
      event.preventDefault()
    }

    const onCanvasClick=(event) => {

    }

    const onCanvasContextMenu=(event) => {
      event.preventDefault()

    }
 
    const renderTabularView = ()=>{
      return (
        <TableDesignView selectedElement = {selectedElement} setSelectedElement = {setSelectedElement} selectedNodes={selectedNodes} elements = {elements}></TableDesignView>
      );
    }
    
    const renderGraphicalView = ()=>{
      return (
        <div className="reactflow-wrapper" ref={reactFlowWrapper}>

        <ReactFlow
        style={styleT}
        panOnScroll={true}
        panOnScrollSpeed = {5}
        elements={elements}
        connectionLineComponent={customConnectionLine}
        nodeTypes={nodeTypes}
        onConnect={onConnect}
        onElementsRemove={onElementsRemove}
        onLoad={onLoad}
        onDrop={onDrop}
        onDragOver={onDragOver}
        onElementClick={onElementClick}
        onSelectionContextMenu={onSelectionContextMenu}  
        onPaneClick={onCanvasClick}
        onPaneContextMenu={onCanvasContextMenu}
        onlyRenderVisibleElements={true}
    
  
      >
        <MiniMap  nodeColor={"#dccca9"} nodeStrokeWidth={3} zoomable pannable/>
        <Controls />
        <Background variant="dots" color="royalblue" gap={10} /> 
  
      </ReactFlow>
      </div>
      );
    }

    const renderDesignerMain = () => {
      var entity = document.getElementById('entity');
      if (entity != null)
      entity.setAttribute('value', entityName)
      // var style = styleT
      // if (tableView == true) {
      //   style = styleG
      // }
      if (viewType == "GRAPHICAL")
        return renderGraphicalView()
      else
      if (viewType == "TABULAR")
        return renderTabularView()
    }  

    const nodeTypes = {
        BizNode: BizNode,
        IfNode:IfNode,
        LoopNode: LoopNode,
        MouseNode:MouseNode,
        EmailNode:EmailNode,
        FileNode:FileNode,
        KeyNode:KeyNode,
        BotNode:BotNode,
        CallNode:CallNode,
        RESTNode:RESTNode,
        WaitNode:WaitNode,
        BrowserNode:BrowserNode,
        SpeakerNode:SpeakerNode,
        SpeechToTextNode:SpeechToTextNode,
        RegularNode:RegularNode
      };
  
      const edgeTypes = {
        buttonedge: ButtonEdge,
      };
  
  
    const changeTitle = (event) => {
      console.log("clicked on entity")
      var entity = document.getElementById('entity')
      var entity2 = document.getElementById('entity2')

      entity.setAttribute('style', 'visibility:hidden')
      entity2.setAttribute('type', 'text') 
      
      console.log("enabled input")

    }  

    const viewTask = (taskname) =>{
      // saveCurrentEntity()
      loadTask(taskname)
    }

    const viewSubTask = (subtaskname) =>{
      // saveCurrentEntity()
      if (objectType == "SUBTASK")
      { 
        console.log("Object type is subtask")
        console.log ("Loading subtask under " + parentEntityName)
        loadSubTask(subtaskname, parentObjectType, parentEntityName)
      }
      else{
        setParentObjectType (objectType)
        setParentEntityName (entityName)
        loadSubTask(subtaskname, objectType, entityName)
      }
    }
 


    const onChange=(event)=>{
      
      setEntityName(event.target.value);
      elements[0].data.label= "Flow:" + event.target.value
      console.log(event.target.value)
    }

    const onFocusOut=(event) => {
      console.log("focus lost")
      var entity = document.getElementById('entity')
      var entity2 = document.getElementById('entity2')
      entity.setAttribute('style', '')
      entity2.setAttribute('type', 'hidden') 
      console.log(entityName)
      entity.setAttribute('innerHtml',  entityName)
      // saveCurrentEntity()


    }

    /* Sent to SimpleTree */
    const useStyles = makeStyles({
        root: {
          flexGrow: 1,
          // maxWidth: 400,
          height:800,
          // backgroundImage: 'linear-gradient(to bottom,  #dccca9, skyblue )',
          
          // color:'#0000b3',
          // color:'black',
          // border: '2px solid #a2c2cc',
          // borderRadius:'10px',
          fontSize:'20',
          fontWeight:'bold',
          overflowY:"scroll",
          '&::-webkit-scrollbar': {
            // width: '0.8em'
            width: '10px',
          },


        // /* Buttons */
        // '&::-webkit-scrollbar-button:single-button': {
        //   backgroundColor: 'rgb(64, 64, 64)',
        //   display: 'block',
        //   backgroundSize: '10px',
        //   backgroundRepeat: 'no-repeat',
        // },

        // /* Up */
        // // '&::-webkit-scrollbar-button:single-button:vertical:decrement': {
        // '&::-webkit-scrollbar-button:vertical:decrement': {
        //     height: '10px',
        //   width: '16px',
        //   backgroundPosition: 'center 4px',
        //   backgroundColor:'slategrey'
        // },

        // '&::-webkit-scrollbar-button:single-button:vertical:increment': {
        //   height: '10px',
        //   width: '16px',
        //   backgroundPosition: 'center 4px',
        //   backgroundColor:'slategrey'
        // },


        // '&::-webkit-scrollbar-track': {
        //     boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        //     webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        //   },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            // backgroundColor: 'lightblue',
            // outline: '1px solid slategrey',
            borderRadius: '30px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor:'slategrey'
          },


          // scrollbarWidth: 'thin',
          // scrollbarColor:'darkblue'
        },
        designerIconButton:{
          float: 'right',
        },
    
      });
      const classes = useStyles();

    const styleG = {
      // background:'#9eccdb',
      // background:'#bed6dd',
      // background:background,

      // backgroundImage: "linear-gradient(to right, #80ffdf, 	#80ffbf	 )",
      width: '100%',
      height: 850
    };

    const designerIconStyle = {
      backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', borderRadius:'20px', padding:'5px', marginLeft:'1px'
    }
  
  const iconStyle = {
    backgroundImage:'linear-gradient(to bottom, grey, royalblue)', color:'white', borderRadius:'20px', padding:'5px', marginLeft:'1px'
  }

  const toolsetIconStyle = {
    // background:'white', 'color':'#8da5ed', boxShadow:'1px 1px 2px 2px lightgrey', borderRadius:'20px', padding:'5px', marginLeft:'1px'
    'color':'#8da5ed', borderRadius:'5px', padding:'3px', marginLeft:'6px'
  }


  // const miniBarIconStyle = {
  //   // backgroundImage:'linear-gradient(to bottom, grey, #8da5ed)', color:'white', borderRadius:'20px', padding:'5px', marginLeft:'1px'
  //   // background:'#8da5ed', color:'white', borderRadius:'20px', padding:'5px', marginLeft:'1px'
  //   background:'#fafafa', color:'royalblue', borderRadius:'20px', padding:'5px', marginLeft:'1px'
  // }

  const [tabs, setTabs] = useState(new Map())

  const closeX = faTimesCircle 
  const iconMap={
    "Bot": faRobot,
    "Task":faList,
    "If": faQuestionCircle,
    "LoopOverArray": faSyncAlt,
    "LoopOverMap": faSyncAlt,
    "LoopCount": faSyncAlt,
    "LoopWhile": faSyncAlt,
    "LoopImageMatch": faSyncAlt,
  }

  const onTabClick=(e)=>{
    // alert(e.target.getAttribute('name'))
    const tab = e.target.getAttribute('name') 
    if (tab != null)
      setSelectedTab(tab)
  }

  const onInfo = () =>{
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'}
    }
    var endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "bot" + '/info/' + entityName 
    if (objectType == "SUBTASK")
      endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "subtask" + '/info/' + parentObjectType + "/" +  parentEntityName +  '/' + entityName

    else if (objectType == "TASK")
      endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "task" + '/info/'  + entityName

    else if (objectType == "TEMPLATE")
      endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "template" + '/info/'  + entityName

      fetch(endpoint, requestOptions)
    .then (async response => {
      const data = await response.text();
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)  
      setBotInfo(data.toString())
      setShowInfo(true)
    })

    .catch(error => {alert("Please ensure that your local agent is running"); return;});
    
  }


  const onBotConfigClick = () =>{
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'}
    }
    var endpoint = 'http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/' + "bot" + '/botconfig/' + entityName 

    fetch(endpoint, requestOptions)
    .then (async response => {
      const data = await response.text();
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)  
      setBotConfig(data.toString())
      setShowBotConfig(true)
    })

    .catch(error => {alert("Please ensure that your local agent is running"); return;});
    
  }




  const onConfigClick=(e)=>{
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'}
    }

    fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bot/config/' + entityName, requestOptions)
    .then (async response => {
      const data = await response.json();
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)  
      setBotMapping(data.toString())
    })

    .catch(error => {alert("Please ensure that your local agent is running"); return;});
  
    const requestOptions2 = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'}
    }

    fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bot/config/transform/' + entityName, requestOptions2)
    .then (async response => {
      const data = await response.json();
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)  
      setTransform(data.toString())
      setShowConfig(true)
    })

    .catch(error => {alert("Please ensure that your local agent is running")});


  }


  const addTab = (type, name)=>{
    console.log("Add Tab: " + type +  name)
    const tab = {
      type:type, name:name
    }
    // tabs.push(type + ":" + name)
    console.log("Adding.." + tab)
    tabs.set(tab.type, tab)
    // setTabs(tabs)
  }


  const hover = (e)=>{
    e.target.setAttribute('backgroundColor', 'grey')
  }
  const closeTab=(e)=>{
    
    console.log(e.target)
    const entry = e.target.getAttribute('name')
    console.log("Deleting " + entry)
    tabs.delete(entry)
  }
  const addTabs = ()=>{
    const allTabs = Array.from(tabs.keys()); 
    return allTabs.map(type => {
      console.log("adding: " + tabs.get(type))

      // var color = '#dcdcdc'
      // if (selectedTab == type)
      // { color = '#f4f4f4'}

 
      return(

      // <div className='tabtitle' onClick={onTabClick} name={type} style={{background:color}}>
      <div className='tabtitle' onClick={onTabClick} name={type} >

        <div name={type} onClick={onTabClick}>

        <LightTooltip title='Close'>
          {/* <label className = 'tabx' name={type}  onClick={closeTab}>x</label> */}
          <div className = 'tabx' name={type} onClick={closeTab}>
          <FontAwesomeIcon name={type}  icon={closeX} color='grey'  size='small'/>
          </div>
          </LightTooltip>



        {/* <LightTooltip title='Display Tab'>   */}
          <div name={type} >
          <TaskIcon name={type} style={designerIconStyle} fontSize="medium" />
          </div>
          {/* </LightTooltip> */}


        </div>

        <label name={type}  className='tabText' >{type}</label>


      </div>
      ) 
    });
  }

// const loadLast = () => {
//   if (historyIndex === 0) return;
//   var item = history[historyIndex - 1];
//   console.log('Loading last item:', item);

//   if (item.type === 'TASK') loadTask(item.name, false, historyIndex - 1);
//   else if (item.type === 'SUBTASK') loadSubTask(item.name, item.parentObjectType, item.parentEntityName, false, historyIndex - 1);
//   else if (item.type === 'TEMPLATE') loadTemplate(item.name, false, historyIndex - 1);
//   else loadBot(item.name, false, historyIndex - 1);

//   setHistoryIndex(historyIndex - 1);
//   console.log('New historyIndex:', historyIndex);
// }

// const loadNext = () => {
//   if (historyIndex + 1 >= history.length) return;
//   var item = history[historyIndex + 1];
//   console.log('Loading next item:', item);

//   if (item.type === 'TASK') loadTask(item.name, false, historyIndex + 1);
//   else if (item.type === 'SUBTASK') loadSubTask(item.name, item.parentObjectType, item.parentEntityName, false, historyIndex + 1);
//   else if (item.type === 'TEMPLATE') loadTemplate(item.name, false, historyIndex + 1);
//   else loadBot(item.name, false, historyIndex + 1);

//   setHistoryIndex(historyIndex + 1);
//   console.log('New historyIndex:', historyIndex);
// }

const loadLast = () => {
  if (historyIndex === 0) return;
  var item = history[historyIndex - 1];
  console.log('Loading last item:', item);

  if (item.type === 'TASK') loadTask(item.name, false, historyIndex - 1);
  else if (item.type === 'SUBTASK') loadSubTask(item.name, item.parentObjectType, item.parentEntityName, false, historyIndex - 1);
  else if (item.type === 'TEMPLATE') loadTemplate(item.name, false, historyIndex - 1);
  else loadBot(item.name, false, historyIndex - 1);

  setHistoryIndex(historyIndex - 1);
  console.log('New historyIndex:', historyIndex);
}

const loadNext = () => {
  if (historyIndex + 1 >= history.length) return;
  var item = history[historyIndex + 1];
  console.log('Loading next item:', item);

  if (item.type === 'TASK') loadTask(item.name, false, historyIndex + 1);
  else if (item.type === 'SUBTASK') loadSubTask(item.name, item.parentObjectType, item.parentEntityName, false, historyIndex + 1);
  else if (item.type === 'TEMPLATE') loadTemplate(item.name, false, historyIndex + 1);
  else loadBot(item.name, false, historyIndex + 1);

  setHistoryIndex(historyIndex + 1);
  console.log('New historyIndex:', historyIndex);
}



  const renderTabs = ()=>{
    // var color = '#dcdcdc'
    // if (selectedTab == 'Bot')
    // { color = '#f4f4f4'}

    var icon = faRobot
    if (objectType == "TASK")
    { icon = faList}

    if (objectType == "TEMPLATE")
    { icon = faThLarge}

    if (objectType == "SUBTASK")
    { icon = faListAlt}

    var configIcon= faWrench
    var infoIcon = faInfoCircle
    var botconfigIcon= faCog

    return (

    <div className='tabTitleColumn'>
    <div className='row'>
    <LightTooltip title="Back">
          {/* <IconButton style = {{visibility:(historyIndex == 0)? "hidden":"visible"}} onClick={()=>loadLast()}> */}
          {/* <IconButton disabled = {(historyIndex == 0)? true:false} onClick={()=>loadLast()}> */}
          <IconButton onClick={()=>loadLast()}>
            <BackIcon style={{color:'grey'}} fontSize="small" />
          </IconButton>
        </LightTooltip>

        <LightTooltip title="Forward">
          {/* <IconButton style = {{visibility:(historyIndex + 1 == history.length)? "hidden":"visible"}} onClick={()=>loadNext()}> */}
          {/* <IconButton disabled = {(historyIndex + 1 == history.length)? true:false} onClick={()=>loadNext()}> */}
          <IconButton onClick={()=>loadNext()}>
            <ForwardIcon style={{color:'grey'}} fontSize="small" />
          </IconButton>
        </LightTooltip>

    </div>
    
    {/* <div className='tabtitle' name='Bot' style={{background:color}} onClick={onTabClick}> */}
    <div className='tabtitle' name='Bot'  onClick={onTabClick}>
          {/* <LightTooltip title='Display tab'> */}
          <div name='Bot'>
            <FontAwesomeIcon   onClick={onTabClick} name='Bot' icon={icon} color='#6787e7'  style={designerIconStyle} size='2x'/>

          </div>
          {/* </LightTooltip > */}
        {(objectType == "SUBTASK")? <h3>({parentEntityName})</h3>:<div/>}
      <h3 id='entity' onClick={changeTitle} >  {entityName}</h3>
      <input id='entity2' onChange={onChange} onBlur={onFocusOut} type='hidden' name='entity2'></input>
      <div/>

      <div className='row' >
        <LightTooltip title='Documentation'>
        <div >
          <FontAwesomeIcon  className="toolbutton" onClick={onInfo} name='Info' icon={infoIcon} color='#6787e7'  style={toolsetIconStyle} size='xs'/>
          </div>
        </LightTooltip>
        {
          objectType == 'BOT'? 
          <div className = 'row'>
              <LightTooltip title='Bot Input Params'>
              <div>
              <FontAwesomeIcon  className="toolbutton" onClick={onConfigClick} name='Config' icon={configIcon} color='#6787e7'  style={toolsetIconStyle} size='xs'/>
              </div>
              </LightTooltip>

              <LightTooltip title='Bot Properties'>
              <div>
              <FontAwesomeIcon  className="toolbutton" onClick={onBotConfigClick} name='BotConfig' icon={botconfigIcon} color='#6787e7'  style={toolsetIconStyle} size='xs'/>
              </div>
              </LightTooltip>
          </div>
          :
          <div/>

        }
      </div>

    </div>
    {/* {renderModeIcon()} */}
    {miniToolBar()}
    {addTabs()}  

    {/* {subTaskTree(mysubtasks)} */}

    </div>
    );

  }

    const subTaskTree = (subtasks) => {
    return (
      <div>
      <h5>SubTasks </h5>

      <div className="subtask-list-container">
        <ul>
          {subtasks.map((subtask, index) => (
            <li key={index}>{subtask}</li>
          ))}
        </ul>
      </div>
      </div>
    );
    }


    const styleT = {
        // background:'#9eccdb',
        // background:'#bed6dd',
        // background:background,

        // backgroundImage: "linear-gradient(to right, #80ffdf, 	#80ffbf	 )",
        width: '100%',
        height: 850

      };



    return (
    <div className="cont">
    <Progress title={"Upload " + uploadStatus} visible = {showProgress} progress={progress} />
    <DeployBot showDeployBot={showDeployBot} setShowDeployBot={setShowDeployBot}/>
    <div className="designer">

    <ReactFlowProvider>


    <SimpleTree title="Activities - drag and drop" data={data} styles={classes}/>

    {renderTabs()}

    {/* <div className='tabtitle'>
    <FontAwesomeIcon icon={faRobot} color='#6787e7' size='2x' style={designerIconStyle}/>
      <h3 id='entity' onClick={changeTitle} >  {entityName}</h3>
      <input id='entity2' onChange={onChange} onBlur={onFocusOut} type='hidden' name='entity2'></input>
    </div> */}

    
    {/* <div style={{display:'flex', flexDirection:'row'}}>            
            {getDesignerView()}
    </div> */}
            
  
    {renderDesignerMain()}



    <Property botName = {entityName} updateProperties = {updateProperties} element={selectedElement} addTab={addTab} getObjectType={getObjectType} getParentObjectType={getParentObjectType} getEntityName={getEntityName} getParentEntityName={getParentEntityName} renderSubTasks = {renderSubTasks} viewTask = {viewTask} viewSubTask = {viewSubTask} viewBot={loadBot}> 
        
    </Property>


    {toolbar()}

    </ReactFlowProvider>

    </div>
    </div>



    );
}
